import Code from "@/components/Code";
import { DatasetUploadModal } from "@/components/DatasetUploadModal";
import FileDropZone from "@/components/FileDropZone";
import { Database01Icon } from "@/icons";
import { Divider } from "@/kit/ui/divider";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { DatasetVersionEditFileFragment$key } from "./__generated__/DatasetVersionEditFileFragment.graphql";

const Fragment = graphql`
  fragment DatasetVersionEditFileFragment on DatasetVersion {
    id
    version
    viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)
    dataset {
      slug
    }
  }
`;

interface Props {
  datasetVersion: DatasetVersionEditFileFragment$key;
  onClose?: () => void;
}

export default function DatasetVersionEditFile({
  datasetVersion: datasetVersionFragment,
  onClose,
}: Props) {
  const [files, setFiles] = useState<File[]>([]);
  const datasetVersion = useFragment(Fragment, datasetVersionFragment);

  return (
    <>
      {datasetVersion.viewerCanCreateDatasetVersion && (
        <>
          <FileDropZone
            value={files}
            onChange={setFiles}
            onBlur={() => {}}
            icon={Database01Icon}
            accept=".json,.jsonl,.csv,.tsv,.parquet"
            directory
          />
          <Divider>
            <FormattedMessage defaultMessage="OR" />
          </Divider>
          <div className="flex flex-col items-start p-4 bg-grey-50 border border-grey-100 rounded-xl gap-3">
            <p className="text-grey-900 text-base font-normal leading-normal">
              <FormattedMessage defaultMessage="Upload via command line:" />
            </p>
            <Code
              content={`aqora dataset upload ${datasetVersion.dataset.slug} <SRC> --version ${datasetVersion.version}`}
            />
          </div>
        </>
      )}

      {files.length > 0 && (
        <DatasetUploadModal
          datasetVersionId={datasetVersion.id}
          files={files}
          onClose={() => {
            setFiles([]);
            onClose?.();
          }}
        />
      )}
    </>
  );
}
